module.exports = __webpack_public_path__ + "static/media/gaida.1077738b.ogg";